import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { GetReviewsQuery } from '@notino/shared/definitions/types';

import { sortFilterBarMessages } from '../messages';

import { ContentTypesFilterContent } from './DrawerContent/ContentTypesFilterContent';
import { CountriesFilterContent } from './DrawerContent/Countries';
import { RatingFilterContent } from './DrawerContent/Rating';
import { VariantsFilterContent } from './DrawerContent/Variants';

export interface FilterChipConfig {
  key: string;
  show: boolean;
  title: React.ReactElement;
  content: React.ReactElement;
}

export const buildFilterChips = (
  filters: NonNullable<GetReviewsQuery['reviewsAndFilters']>['filter']
): FilterChipConfig[] => {
  if (!filters) {
    return [];
  }

  const { rating, contentTypes, variants, shops } = filters;

  return [
    {
      key: 'rating',
      show: !!rating && Object.keys(rating).some((key) => rating[key] > 0),
      title: <FormattedMessage {...sortFilterBarMessages.rating} />,
      content: <RatingFilterContent />,
    },
    {
      key: 'contentTypes',
      show:
        !!contentTypes &&
        contentTypes.length > 0 &&
        contentTypes.some(({ count }) => (count ?? 0) > 0),
      title: <FormattedMessage {...sortFilterBarMessages.reviewContent} />,
      content: <ContentTypesFilterContent />,
    },
    {
      key: 'variants',
      show:
        !!variants &&
        variants.length > 1 &&
        variants.some(({ count }) => (count ?? 0) > 0),
      title: <FormattedMessage {...sortFilterBarMessages.productVariant} />,
      content: <VariantsFilterContent />,
    },
    {
      key: 'shops',
      show:
        !!shops &&
        shops.length > 1 &&
        shops.some(({ count }) => (count ?? 0) > 0),
      title: <FormattedMessage {...sortFilterBarMessages.reviewCountry} />,
      content: <CountriesFilterContent />,
    },
  ];
};
